// utilise jquery chargé en global

// all custom javascript page effect, content adujstement, ... will be here

require('./hapi-page-extra.scss');

$( document ).ready(function() {
	hapi_bigtarget();

	stopPropagation();
});

function hapi_bigtarget(){
	$('[data-bigtarget]:not(.bigtarget-init)').each(function(){
		$(this).addClass('bigtarget-init');
		var zone = $(this).parents($(this).data('bigtarget')).eq(0);
		zone.addClass('hapi-bigtarget');
		zone.on('mouseover',function(){ $(this).addClass('over'); });
		zone.on('mouseout',function(){ $(this).removeClass('over'); });
		zone.on('click',function(event){
			if(zone.data('triggerDelay')===true)
			{
				//console.log("bigtarget:dedup event")
			}
			else
			{
				//console.log("bigtarget:trigger click")
				zone.data('triggerDelay',true)
				setTimeout(function(){
					this.data('triggerDelay',false)
				}.bind(zone))
				$(this).find('[data-bigtarget]').eq(0)[0].click()
			}
		})
	})
}

function stopPropagation()
{
	$('.stopPropagation').on('click',function(event){
		event.stopPropagation()
	})
}